import React from 'react';
import { object } from 'prop-types';
import { Loader } from '@fiverr-private/fit';

const PickerLoader = ({ style }) => (
    <section className="flex flex-center" style={style}>
        <Loader/>
    </section>
);

PickerLoader.propTypes = {
    style: object
};

export default PickerLoader;
